import * as activity from 'activityConfigES';
activity.stat();

export const doStatistics = function () {

  activity.listen({ 
  'j-sign-progress-btn-1': '签到按钮-1-次数',
  'j-sign-progress-btn-2': '签到按钮-2-次数',
  'j-sign-progress-btn-3': '签到按钮-3-次数',
  'j-sign-progress-btn-4': '签到按钮-4-次数',
  'j-sign-progress-btn-5': '签到按钮-5-次数',
  'j-sign-progress-btn-6': '签到按钮-6-次数',
  'j-sign-progress-btn-7': '签到按钮-7-次数',
  'j-sign-progress-light-btn-1': '签到按钮-1-次数',
  'j-sign-progress-light-btn-2': '签到按钮-2-次数',
  'j-sign-progress-light-btn-3': '签到按钮-3-次数',
  'j-sign-progress-light-btn-4': '签到按钮-4-次数',
  'j-sign-progress-light-btn-5': '签到按钮-5-次数',
  'j-sign-progress-light-btn-6': '签到按钮-6-次数',
  'j-sign-progress-light-btn-7': '签到按钮-7-次数'
  }, 'click');

  activity.listen({ 
    'j-sign-progress-btn-1': '签到按钮-1-人数',
    'j-sign-progress-btn-2': '签到按钮-2-人数',
    'j-sign-progress-btn-3': '签到按钮-3-人数',
    'j-sign-progress-btn-4': '签到按钮-4-人数',
    'j-sign-progress-btn-5': '签到按钮-5-人数',
    'j-sign-progress-btn-6': '签到按钮-6-人数',
    'j-sign-progress-btn-7': '签到按钮-7-人数',
    'j-sign-progress-light-btn-1': '签到按钮-1-人数',
    'j-sign-progress-light-btn-2': '签到按钮-2-人数',
    'j-sign-progress-light-btn-3': '签到按钮-3-人数',
    'j-sign-progress-light-btn-4': '签到按钮-4-人数',
    'j-sign-progress-light-btn-5': '签到按钮-5-人数',
    'j-sign-progress-light-btn-6': '签到按钮-6-人数',
    'j-sign-progress-light-btn-7': '签到按钮-7-人数',
    'j-virture-get-reward-1-succ': '签到礼包-1-人数',
    'j-virture-get-reward-2-succ': '签到礼包-2-人数',
    'j-virture-get-reward-3-succ': '签到礼包-3-人数',
    'j-virture-get-reward-4-succ': '签到礼包-4-人数',
    'j-virture-get-reward-5-succ': '签到礼包-5-人数',
    'j-virture-get-reward-6-succ': '签到礼包-6-人数',
    'j-virture-get-reward-7-succ': '签到礼包-7-人数'
    }, 'user');
};
